
export function logErrorToMyService(error, errorInfo) {
        console.log(error, errorInfo)
}